import Vue from 'vue'
import vuetify from './plugins/vuetify'
import { VApp } from "vuetify/lib";
import axios from "axios";
import vueCustomElement from 'vue-custom-element'
import CcresVisuMonthly from "./components/CcresVisuMonthly"

// Vue.prototype.$prodPrefix = "http://localhost:8080/"

Vue.use(vueCustomElement);
Vue.use(axios);



Vue.customElement('ccres-visu-monthly', {
  vuetify: vuetify,
  components: { VApp, CcresVisuMonthly },
  template: `<v-app id='app'><ccres-visu-monthly></ccres-visu-monthly></v-app>`
})




// npm run build -- --target lib --name ccres-visu-monthly src/main.production.monthly.js